export interface ProgressBarProps {
  /** 0..1 */
  value: number;
  label?: string;
}

export function ProgressBar({ value, label }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(1, value));
  return (
    <div className="jaiho-progress" role="progressbar" aria-valuenow={Math.round(clamped * 100)} aria-valuemin={0} aria-valuemax={100}>
      <div className="jaiho-progress__track">
        <div className="jaiho-progress__fill" style={{ width: `${clamped * 100}%` }} />
      </div>
      {label && <div className="jaiho-progress__label">{label}</div>}
    </div>
  );
}
